import CardContent from '@/components/base/card/card-content.component';
import Card from '@/components/base/card/card.component';
import { Alert, Chip, Grid, Typography } from '@mui/material';
import { useGetAddressesByBusinessPartnerId } from '@/api/business-partner/business-partner.hooks.ts';
import { Address } from '@/api/business-partner/business-partner.types.ts';
import { useTranslation } from 'react-i18next';

function AddressCard({ address }: { address: Address }) {
  const { t } = useTranslation('customer');

  return (
    <Grid
      size={{
        xs: 12,
        sm: 6,
        md: 4,
      }}
    >
      <Card elevation={4}>
        <CardContent
          sx={{
            pt: 2,
          }}
        >
          <Typography variant="h6">{address.addressName2}</Typography>
          {address.addressName3 && (
            <Typography>{`${address.addressName3}`}</Typography>
          )}
          <Typography>{`${address.street}`}</Typography>
          <Typography>{`${address.zipCode} ${address.city} ${address.country}`}</Typography>

          <Chip
            size="small"
            variant="filled"
            color={
              address.addressType === 'bo_ShipTo' ? 'primary' : 'secondary'
            }
            label={
              address.addressType === 'bo_ShipTo'
                ? t('account.myAddresses.types.shipping')
                : t('account.myAddresses.types.billing')
            }
            sx={{ mt: 1 }}
          />
        </CardContent>
      </Card>
    </Grid>
  );
}

export default function MyAddressesComponent() {
  const { t } = useTranslation('customer');
  const { data: addresses, isPending: isAddressesPending } =
    useGetAddressesByBusinessPartnerId();

  return (
    <>
      <Alert severity="info" sx={{ mb: 2 }} elevation={2}>
        {t('account.myAddresses.changeNotice')}
      </Alert>
      {isAddressesPending ? (
        <Typography>{t('account.myAddresses.loading')}</Typography>
      ) : (
        <Grid container spacing={2}>
          {addresses?.map((address) => (
            <AddressCard key={address.id} address={address} />
          ))}
        </Grid>
      )}
    </>
  );
}
